module.exports = __webpack_public_path__ + "static/media/file1.2461d86b.jpg";